<script>
import appConfig from '@/app.config'
import { mapState } from 'vuex'
import ReleaseNotes from '@/components/releaseNotes/ReleaseNotesCard.vue'
import Search from '@/components/general/expand-search.vue'
import Spinner from '@/components/general/spinner.vue'
import formatDate from '@/utils/format-date'

export default {
  components: { ReleaseNotes, Search, Spinner },
  props: {
    embedded: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      activeReleaseId: '',
      search: '',
      loading: false,
    }
  },
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: appConfig.description }],
    }
  },
  computed: {
    ...mapState('releases', ['releases', 'roadmap']),
    activeRelease() {
      const matchingRelease = this.$store.getters['releases/getReleaseById'](
        this.activeReleaseId
      )

      return matchingRelease?.id ? matchingRelease : {}
    },
  },

  mounted() {
    this.activeReleaseId =
      this.$route?.query?.releaseId ??
      (this.releases.length ? this.releases[0].releaseId : '')
  },
  methods: {
    async getReleaseById(id) {
      // check for id in local releases
      const matchingRelease = this.$store.getters['releases/getReleaseById'](id)
      if (matchingRelease) {
        this.activeReleaseId = matchingRelease.releaseId
        return
      }

      // Go get release from db
      this.loading = true
      const result = await this.$store.dispatch('releases/getReleaseById', id)

      if (result?.data) this.activeReleaseId = result.data

      this.loading = false
    },
    formatDate,
  },
}
</script>

<template>
  <v-container :class="{ 'embedded-container': embedded }">
    <div
      v-if="!embedded"
      class="d-flex"
      :class="{ 'flex-column': $vuetify.breakpoint.smAndDown }"
    >
      <h1 class="ml-2">Releases</h1>
      <Search
        placeholder="Type a Release Id and hit enter"
        emit="getReleaseById"
        :class="{ 'ml-4': $vuetify.breakpoint.mdAndUp }"
        @getReleaseById="getReleaseById"
      />
    </div>
    <div v-if="!loading">
      <v-chip-group
        v-if="releases.length"
        v-model="activeReleaseId"
        class="chip-group my-4"
        show-arrows
      >
        <transition-group name="fade-left">
          <v-chip
            v-for="{ releaseId, dateCreated } in releases"
            :key="releaseId"
            label
            :elevation="24"
            filter
            :value="releaseId"
            color="primary"
            active-class="active-chip"
            class="release-chip text-center mr-4"
          >
            {{ formatDate(dateCreated) }}
          </v-chip>
        </transition-group>
      </v-chip-group>
      <transition name="fade-up">
        <ReleaseNotes
          v-if="activeRelease.id"
          :release="activeRelease"
          :embedded="embedded"
        />
      </transition>
    </div>
    <Spinner v-else class="mt-12" size="60" />
  </v-container>
</template>

<style lang="scss" scoped>
.release-chip {
  padding: 20px;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  color: white;
  letter-spacing: 3px;
  opacity: 0.3;
}

.active-chip {
  opacity: 1;
}
</style>
